import { useState } from 'react';
import SmartNavbar from '../SmartNavbar';
import Footer from '../Footer';
import SEO from '../SEO';

// Components
import Sidebar from './components/Sidebar';

// Sections
import Introduction from './sections/Introduction';
import Authentication from './sections/Authentication';
import Screenshot from './sections/Screenshot';
import BatchProcessing from './sections/BatchProcessing';
import ScreenshotParameters from './sections/ScreenshotParameters';
import Features from './sections/Features';
import DeviceEmulation from './sections/DeviceEmulation';
import PDFGeneration from './sections/PDFGeneration';
import Errors from './sections/Errors';
import RateLimits from './sections/RateLimits';

export default function Documentation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="API Documentation - Snaptura"
        description="Complete API documentation for Snaptura screenshot and PDF generation API. Learn how to capture screenshots, generate PDFs, use device emulation, and more."
        url="/docs"
      />
      {/* Add Navbar at the top */}
      <SmartNavbar />

      {/* Mobile Menu Button - Floating */}
      <button
        onClick={() => setMobileMenuOpen(true)}
        className="lg:hidden fixed bottom-6 right-6 z-40 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-colors"
        aria-label="Open navigation menu"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      {/* Documentation Layout */}
      <div className="flex">
        {/* Sidebar Navigation */}
        <Sidebar
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
            {/* Documentation Sections */}
            <Introduction />
            <Authentication />
            <Screenshot />
            <BatchProcessing />
            <ScreenshotParameters />
            <Features />
            <DeviceEmulation />
            <PDFGeneration />
            <Errors />
            <RateLimits />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}